import { apiSlice } from "../../apiSlice";

/**
 * Ver como cargo (administradores): menú que hereda un cargo desde su plantilla de permisos
 */
export const vercomoApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getMenuCargo: builder.query({
      query: (CARIDXXX) => ({
        url: `/Usuarios/Vercomo/menu/${CARIDXXX}`,
        method: "GET",
        headers: { modulecima: "usuarios" },
      }),
    }),
  }),
});

export const { useLazyGetMenuCargoQuery } = vercomoApiSlice;
